import React, { useEffect, useState } from "react";
import {
  Navbar,
  Nav,
  Button,
  Offcanvas,
  Container,
  Spinner,
  Table,
} from "react-bootstrap";
import "../style/admin.css";
import Moment from "react-moment";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { RxHamburgerMenu } from "react-icons/rx";
import { apibasePath } from "../config";

import { List } from "react-bootstrap-icons";

const Item = () => {
  const [show, setShow] = useState(false);
  const [stock, setStock] = useState([]);
  const [logo, setLogo] = useState(null);
  const [name, setName] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const Api_Url = `${apibasePath}/client/cart-details/123/`;
  const Api_url = `${apibasePath}/client/profiles/company/`;
  const Token = localStorage.getItem("authToken");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let res = await axios.get(Api_Url, {
          headers: { Authorization: `bearer ${Token}` },
        });
        setStock(res?.data);
        setLoading(false);
      } catch (error) {
        console.error("error", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await axios.get(Api_url, {
          headers: { "Content-Type": "application/json" },
        });
        setLogo(response.data.logo);
        setName(response.data.name);
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    };
    fetchLogo();
  }, []);

  //brandlogo
  const Api = `${apibasePath}/client/profiles/brand/`;
  const [brandLogo, setBrandLogo] = useState(null);

  useEffect(() => {
    const fetchdata = async () => {
      try {
        setLoading(true);
        let response = await axios.get(Api, {
          headers: { "Content-Type": "application/json" },
        });
        console.log("responseeeeeeeeee", response);
        setBrandLogo(response.data.logo);
        setLoading(false);
      } catch (error) {
        console.error(error);
      }
    };

    fetchdata();
  }, []);

  const Api_item = `${apibasePath}/client/customer-all-items/`;
  const [item, setItem] = useState([]);
  useEffect(() => {
    const fetchdata = async () => {
      try {
        setLoading(true);
        let response = await axios.get(Api_item, {
          headers: {
            Authorization: `bearer ${Token}`,
            "Content-Type": "application/json",
          },
        });
        console.log("respogfsgdhsah", response);
        setItem(response.data);
        setLoading(false);
      } catch (error) {
        console.error(error);
      }
    };

    fetchdata();
  }, []);
  //loading
  if (loading) {
    return (
      <div
        style={{
          top: "50%",
          left: "50%",
          translate: ("-50%", "-50%"),
          position: "absolute",
        }}
        className="slide"
      >
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <>
      {/* Top Navbar */}
      <Navbar bg="light" variant="dark" expand="lg" className="px-3 fixed-top">
        <Container fluid>
          <Navbar.Brand className="ms-2">
            <div className="logo-container">
              {logo && <img src={logo} alt="Company Logo" />}
            </div>
          </Navbar.Brand>
          <Navbar.Brand
            style={{
              color: "#23395B",
              fontFamily: "Roboto",
              fontWeight: "600",
              marginRight: "auto",
              fontSize: "17px",
            }}
          >
            {name}
          </Navbar.Brand>
          <Button
            variant="outline-light"
            className="d-lg-none"
            onClick={handleShow}
          >
            <RxHamburgerMenu
              style={{
                width: "30px",
                height: "30px",
                cursor: "pointer",
                color: "#000",
              }}
            />
          </Button>
        </Container>
      </Navbar>

      {/* Sidebar for Large Screens */}
      <div className="sidebar d-none d-lg-block">
        <Nav className="flex-column p-3">
          <Nav.Link href="/admin-dashboard" className="active">
            CUSTOMER RESTRICTION DETAIL
          </Nav.Link>
          {/* <Nav.Link href="/stock-list">STOCK LIST</Nav.Link> */}
          <Nav.Link href="/add-cart">ADD TO CART SUMMARY</Nav.Link>
          {/* <Nav.Link href="/createcustomer">CREATE CUSTOMER </Nav.Link> */}

          {/* <Nav.Link href="/item">ITEM</Nav.Link> */}
        </Nav>
      </div>

      {/* Offcanvas Sidebar for Mobile and Tablets */}
      <Offcanvas
        className="two"
        show={show}
        onHide={handleClose}
        responsive="lg"
      >
        <Offcanvas.Header
          className="custom-offcanvas-header"
          variant="light"
          closeButton
        >
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">
            <Nav.Link href="/admin-dashboard" className="active">
              CUSTOMER RESTRICTION DETAIL
            </Nav.Link>
            {/* <Nav.Link href="/stock-list">STOCK LIST</Nav.Link> */}
            <Nav.Link href="/add-cart">ADD TO CART SUMMARY</Nav.Link>
            {/* <Nav.Link href="/createcustomer">CREATE CUSTOMER </Nav.Link> */}

            {/* <Nav.Link href="/item">ITEM</Nav.Link> */}
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Main Content */}
      <main className="content">
        <div className="header-section">
          <h2 style={{ fontFamily: "Roboto", color: "#35646E" }}>Item</h2>
          {/* <Button className="btn " style={{backgroundColor:'#396D72',border:'none'}}>CREATE CUSTOMER RESTRICTION</Button> */}
        </div>

        <Table className="table" responsive striped bordered hover>
          <thead>
            <tr style={{ color: "#35646E", borderBottom: "1px solid black" }}>
              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              >
                Customer Code
              </th>
              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              >
                Item Code
              </th>
              {/* <th style={{ backgroundColor: '#C5CACF', color: '#35646E', fontFamily: 'Roboto' }}>Item Tag</th> */}
              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              >
                Item Name
              </th>
              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              >
                From Gross Weight
              </th>
              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              >
                To Gross Weight
              </th>
              {/* <th style={{ backgroundColor: '#C5CACF', color: '#35646E', fontFamily: 'Roboto' }}>Net Weight</th> */}
            </tr>
          </thead>
          <tbody>
            {item.map((e) => (
              <tr style={{ color: "#35646E", borderBottom: "1px solid black" }}>
                <td
                  data-label="Customer Code"
                  style={{
                    backgroundColor: "#C5CACF",
                    color: "#35646E",
                    fontFamily: "Roboto",
                  }}
                >
                  {e.customer_code || "N/A"}
                </td>
                <td
                  data-label="Item Code"
                  style={{
                    backgroundColor: "#C5CACF",
                    color: "#35646E",
                    fontFamily: "Roboto",
                  }}
                >
                  {e.item_code || "N/A"}
                </td>
                {/* <td data-label="Item Tag" style={{ backgroundColor: '#C5CACF', color: '#35646E', fontFamily: 'Roboto' }}>{e.item_tag}</td> */}
                <td
                  data-label="Item Name"
                  style={{
                    backgroundColor: "#C5CACF",
                    color: "#35646E",
                    fontFamily: "Roboto",
                  }}
                >
                  {e.item_name || "N/A"}
                </td>
                <td
                  data-label="Gross Weight"
                  style={{
                    backgroundColor: "#C5CACF",
                    color: "#35646E",
                    fontFamily: "Roboto",
                  }}
                >
                  {e.from_gross_weight || "N/A"}{" "}
                </td>
                <td
                  data-label="Stone Weight"
                  style={{
                    backgroundColor: "#C5CACF",
                    color: "#35646E",
                    fontFamily: "Roboto",
                  }}
                >
                  {e.to_gross_weight || "N/A"}
                </td>
                {/* <td data-label="Net Weight" style={{ backgroundColor: '#C5CACF', color: '#35646E', fontFamily: 'Roboto' }}>{e.net_weight}</td> */}
              </tr>
            ))}
          </tbody>
        </Table>

        <div align="center" style={{ fontFamily: "Roboto", marginTop: "30px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <h4
              align="center"
              style={{ fontSize: "14px", marginTop: "31px", color: "#35646E" }}
            >
              POWERED BY
            </h4>
            <div
              style={{
                width: "100px",
                height: "50px",
                borderRadius: "10px",
                overflow: "hidden",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "5px", //add some space between text and logo
              }}
            >
              <img
                src={brandLogo}
                alt="Brandlogo"
                style={{
                  width: "100%",
                  height: "100%",
                  backgroundSize: "cover",
                }}
              />
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Item;
